export const ApiSettingsCalendar = (axios, obuBaseUrl) => {
  axios.setBaseURL(obuBaseUrl)

  const saveRestrictions = async (payload) => {
    const result = await axios.post('/api/settings/calendar/restrictions', payload)
    return result.data
  }

  const saveOptions = async (payload) => {
    const result = await axios.post('/api/settings/calendar/options', payload)
    return result.data
  }

  const find = async (id) => {
    const result = await axios.get(`/api/settings/calendar/${id}`)
    return result.data
  }

  const remove = async (id) => {
    const result = await axios.delete(`/api/settings/calendar/${id}`)
    return result.data
  }

  const loadRestrictions = async () => {
    const result = await axios.get('/api/settings/calendar/restrictions')
    return result.data
  }

  return {
    calendarSettingSaveOptions: saveOptions,
    calendarSettingFind: find,
    calendarSettingLoadRestrictions: loadRestrictions,
    calendarSettingRemove: remove,
    calendarSettingSaveRestrictions: saveRestrictions
  }
}
